export var IndentWidthType;
(function (IndentWidthType) {
    IndentWidthType[IndentWidthType["NONE"] = 0] = "NONE";
    IndentWidthType[IndentWidthType["XXSMALL"] = 1] = "XXSMALL";
    IndentWidthType[IndentWidthType["XSMALL"] = 2] = "XSMALL";
    IndentWidthType[IndentWidthType["SMALL"] = 3] = "SMALL";
    IndentWidthType[IndentWidthType["MEDIUM"] = 4] = "MEDIUM";
    IndentWidthType[IndentWidthType["LARGE"] = 5] = "LARGE";
    IndentWidthType[IndentWidthType["XLARGE"] = 6] = "XLARGE";
})(IndentWidthType || (IndentWidthType = {}));
//# sourceMappingURL=IndentWidthType.js.map